<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3 w-100">
      <h4 class="title"><i class="fas fa-user-lock"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success mw-180 custom-button"
              *ngIf="hasAuthority('own:sie:add:credential')"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="row mt-2">
    <div class="col-md-3 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadSiecredentials0()">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
      <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="enterpriseSelected"
                (ngModelChange)="reloadSiecredentials()">
          <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}" *ngIf="hasRole(ROLE_PARTNER)"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.USER' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.VERSION' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE-AT' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.CERTIFICATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE-ISSUE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.EXPIRATION-DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let siecredential of siecredentials; let index=index"
          class="{{hasRole(ROLE_PARTNER)?'custom-font-size-table-body':'custom-font-size-table-body-isnt-partner'}}">
        <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
        <td title="Empresa" *ngIf="hasRole(ROLE_PARTNER)">{{siecredential._more.enterpriseName}}</td>
        <td title="Usuario">{{siecredential.username}}</td>
        <td title="Versión">{{siecredential.version}}</td>
        <td title="Fecha registro">{{siecredential.createAt | dateformat}}</td>
        <td title="Certificado">{{siecredential._more.certificateName}}</td>
        <td title="Fecha emisión">{{siecredential._more.certificateNotBefore | dateformat}}</td>
        <td title="Fecha expiración">{{siecredential._more.certificateNotAfter | dateformat}}</td>
        <td title="Estado"><span
          class="{{!siecredential.active? 'badge badge-danger':''}}">{{siecredential.active ? ('LABEL.ACTIVE' | translate) : ('LABEL.INACTIVE' | translate)}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <label class="mr-1 font-weight-normal">Mostrar </label>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadCredentials(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <label class="font-weight-normal"> registros.</label>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{siecredentials.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadCredentials(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadCredentials(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadCredentials(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadCredentials(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
